import jQuery from 'jquery';
window.jQuery = window.$ = jQuery;

import 'foundation-sites/js/entries/foundation';
import 'foundation-sites/js/entries/foundation-plugins';

import PubSub from 'pubsub-js';

import decodeHtml from './../helpers/decodeHtml'

class ResponsiveSidebar {

  constructor(elm) {
    this._elm = $(elm);
    this._targetHash = this._elm.data('responsive-sidebar');

    this._desktopSidebar = this._elm;
    this._mobileSidebar = $(this._targetHash);

    this._currentScreen;
    this._previousScreen = Foundation.MediaQuery.current;

    this._htmlSidebar = decodeHtml( this._elm.data('content') );
    this._elm.removeAttr('data-content');

    this.rearrangeFilters();

    $(window).on('changed.zf.mediaquery', (event) => {
      this._currentScreen = Foundation.MediaQuery.current;
      if (this._previousScreen !== this._currentScreen) {
        //console.log('old: '+this._previousScreen+' - new: '+this._currentScreen);
        this.rearrangeFilters();
      }
      this._previousScreen = this._currentScreen;
    });
  }

  rearrangeFilters() {
    let changed = false;

    if (Foundation.MediaQuery.atLeast('xlarge')) {
      // console.log('large or bigger - Should be on sidebar');
      if (!this._desktopSidebar.is('.has-content')) {
        this._desktopSidebar.html(this._htmlSidebar).addClass('has-content');
        this._mobileSidebar.html('').removeClass('has-content');

        changed = true;
      }
    } else {
      // console.log('smaller than large - Should be on Offcanvas');
      if (!this._mobileSidebar.is('.has-content')) {
        let sidebar = $(this._htmlSidebar);
        sidebar.find('.is-active').removeClass('is-active');

        this._mobileSidebar.html(sidebar).addClass('has-content');
        this._desktopSidebar.html('').removeClass('has-content');

        changed = true;
      }
    }

    if (changed) {
      PubSub.publish('ResponsiveSidebar_changed', 'The responsive sidebar changed place.');
    }

  }
}

export default ResponsiveSidebar;
